module.exports = __webpack_public_path__ + "img/greater_demon_cage_small.e7e9b9da.png";